﻿import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Checkbox, Collapse, Icon } from "@blueprintjs/core";

import { ShowHide } from "components/layout";
import 'components/form-fields/FormFields.css';

export function FormGroupedCheckboxItems(
    {
        searchable = false,
        showTags = false,
        filter = null,
        itemIcon = null,
        disabled = false,
        singleSelection = false,
        groupsSelectable,
        items,
        loading,
        onGroupSelect,
        onGroupToggle,
        onItemSelect,
        searchTerm
    }
) {

    function calculateSelectedChildren(itemsValue, count) {

        var selectedItems = 0;

        if (itemsValue == null) {
            return count;
        }

        for (var i = 0; i < itemsValue.length; i++) {
            var currentItem = itemsValue[i];

            if (currentItem.type === "group" && currentItem.items != null && currentItem.items.length > 0) {
                count = calculateSelectedChildren(currentItem.items, count);
            }

            if (currentItem.type === "item" && currentItem.checked && (searchTerm.length === 0 || currentItem.appearInSearch)) {
                selectedItems++;
            }

        }

        return count + selectedItems;
    }

    function onItemSelectValue(itemId, itemDisabled, event) {
        event.stopPropagation();
        event.preventDefault();

        if (!disabled && !itemDisabled) {
            onItemSelect(itemId)
        }
    }

    return (
        <div>
            {
                items != null && items.map(function (item) {

                    var displayForSearch = searchTerm.length > 0 && item.appearInSearch;

                    if (item.type === "group") {
                        return (
                            <ShowHide
                                key={`group-${item.id}`}
                                evaluator={searchTerm.length === 0 || item.appearInSearch}
                                show={(
                                    <div>
                                        <div className={classNames("grouped-checkbox-row", `checkbox-list-group-${item.id}`, { "bp6-skeleton": loading })}>
                                            <h4 onClick={() => { onGroupToggle(item.id) }} onKeyDown={(e) => { }}><Icon className="collapsable-icon-status" icon={item.expanded ? "chevron-down" : "chevron-right"} />{item.name} <span className="grouped-checkbox-select-count">{singleSelection ? '' : `(${calculateSelectedChildren(item.items, 0)} selected)`}</span></h4>
                                            <ShowHide
                                                evaluator={groupsSelectable}
                                                show={(
                                                    <Checkbox checked={item.checked} indeterminate={item.partialChecked} onChange={() => { onGroupSelect(item.id); }} disabled={item.disabled || disabled} />
                                                )}
                                            />
                                        </div>
                                        <Collapse isOpen={item.expanded || displayForSearch} className="grouped-checkbox-list">
                                            <FormGroupedCheckboxItems items={item.items} searchTerm={searchTerm} groupsSelectable={groupsSelectable} onGroupToggle={onGroupToggle} onItemSelect={onItemSelect} onGroupSelect={onGroupSelect} loading={loading} filter={filter} itemIcon={itemIcon} disabled={disabled} singleSelection={singleSelection} />
                                        </Collapse>
                                    </div>
                                )}
                                
                            />
                        );
                    } else {
                        return (
                            <ShowHide
                                key={`item-${item.id}`}
                                evaluator={(searchTerm.length === 0 || item.appearInSearch) && (filter == null || filter(item))}
                                show={(
                                    <div 
                                        key={`item-${item.id}`} 
                                        onClick={(e) => { onItemSelectValue(item.id, item.disabled, e) }}
                                        onKeyDown={() => {}}
                                        className={classNames("grouped-checkbox-row", { "bp6-skeleton": loading, "checkbox-list-single-click": singleSelection })} 
                                    >
                                        <span>
                                            <ShowHide
                                                evaluator={itemIcon != null}
                                                show={(
                                                    <Icon className="collapsable-icon-status" icon={itemIcon} />
                                                )}
                                            />
                                            <label>{item.name}</label>
                                        </span>
                                        <ShowHide
                                            evaluator={!singleSelection}
                                            show={(
                                                <Checkbox checked={item.checked} onChange={(e) => { onItemSelectValue(item.id, item.disabled, e) }} disabled={item.disabled || disabled} />
                                            )}
                                        />
                                    </div>
                                )}
                            />
                        );
                    }
                })
            }
        </div>
    );
}

FormGroupedCheckboxItems.propTypes = {
    searchable: PropTypes.bool,
    showTags: PropTypes.bool,
    filter: PropTypes.func,
    itemIcon: PropTypes.string,
    disabled: PropTypes.bool,
    singleSelection: PropTypes.bool
};
